import ExperimentalBanner from "../../../../src/components/experimental-banner.js";
import * as React from 'react';
export default {
  ExperimentalBanner,
  React
};